import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  HomeIcon,
  UsersIcon,
  ClockIcon,
  CurrencyDollarIcon,
  Cog6ToothIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';
import { useTheme } from '../../context/ThemeContext';

const navItems = [
  { path: '/dashboard', label: 'Inicio', icon: HomeIcon },
  { path: '/empleados', label: 'Empleados', icon: UsersIcon },
  { path: '/asistencias', label: 'Asistencias', icon: ClockIcon },
  { path: '/aprobar-justificaciones', label: 'Aprobar', icon: ShieldCheckIcon },
  { path: '/nomina', label: 'Nómina', icon: CurrencyDollarIcon },
  { path: '/configuracion', label: 'Ajustes', icon: Cog6ToothIcon },
];

export const MobileNav: React.FC = () => {
  const { isDark } = useTheme();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 h-16 backdrop-blur-md border-t pb-safe z-40"
      style={{
        backgroundColor: isDark
          ? 'rgba(10, 14, 39, 0.9)'
          : 'rgba(245, 247, 255, 0.9)',
        borderColor: isDark ? 'rgba(255,255,255,0.1)' : 'rgb(229,231,235)',
      }}
    >
      <ul className="flex items-center justify-around h-full">
        {navItems.map((item) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-xl transition-colors ${
                  isActive
                    ? 'text-accent'
                    : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
                }`
              }
              style={({ isActive }) => ({
                color: isActive
                  ? 'var(--color-accent, #3949AB)'
                  : isDark
                    ? '#9CA3AF'
                    : '#6B7280',
              })}
            >
              <item.icon className="w-5 h-5" />
              <span className="text-xs">{item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
